import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, darkGrayFontColor, kitTintColor, success } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	accountActiveNumber: {
		color: success,
		fontSize: 42,
		fontWeight: 600,
	},
	accountsStatsHeader: {
		display: 'flex',
		justifyContent: 'flex-start',
		margin: '20px 0 40px',
	},
	accountsTitle: {
		fontSize: 24,
		minWidth: 180,
		paddingLeft: 10,
	},
	accountTotalDesc: {
		color: darkGrayFontColor,
		display: 'inline-block',
		fontSize: 11,
		letterSpacing: 1.1,
		marginLeft: 10,
		textOverflow: 'wrap',
		textTransform: 'uppercase',
		width: 65,
	},
	accountTotalNumber: {
		color: brandPrimaryText,
		fontSize: 42,
		fontWeight: 600,
	},
	checkboxContainer: {
		display: 'flex',
		gap: 16,
		marginLeft: 50,
		flexWrap: 'wrap',
	},
	checkboxFilter: {
		display: 'grid',
		gridTemplateColumns: 'auto auto',
		alignItems: 'center',
		columnGap: '8px',
		rowGap: 4,
		color: darkGrayFontColor,
		fontSize: 12,
		textTransform: 'uppercase',
		alignContent: 'flex-start',
	},
	percentLabel: {
		gridColumn: 2,
	},
	flagged: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 8,
	},
	green: {
		color: success,
	},
	orange: {
		color: kitTintColor,
	},
	red: {
		color: '#D0021B',
	},
	yellow: {
		color: '#F3CE0D',
	},
});
